import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    container: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        paddingBottom: "100px",
    },
    paper: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "65%",
        borderRadius: "15px",
        padding: "30px 0",
        marginTop: "80px",
        backgroundColor: "#CCCCCC",
    },
    contact: {
        color: "white",
        textAlign: "center",
        fontFamily: "Garamond",
        paddingTop: "4rem",
    },
    form: {
        display: "block",
        justifyContent: "center",
        alignItems: "center",
        padding: "0 4rem 2rem",
    },
    formField: {
        margin: "2rem 0",
    },
    formLabel: {
        fontSize: "30px",
        textAlign: "center",
    },
    buttonSubmit: {
        width: "50%",
        backgroundColor: "#8BD3E6",
        margin: "3rem 0 1rem",
        "&:hover": {
            backgroundColor: "#4cbbd8",
        },
        borderRadius: "13px",
    },
    buttonSubmitContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
}));

export default useStyles;
